import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="py-24 text-center">
      <h1 className="text-6xl font-bold text-green-500">404</h1>
      <p className="mt-4 text-xl text-white">Page not found</p>
      <p className="mt-2 text-gray-400">The page you're looking for doesn't exist.</p>
      <Link to="/" className="mt-8 inline-block rounded-lg bg-green-600 px-6 py-3 text-white hover:bg-green-500 transition-colors">
        Go Home
      </Link>
    </div>
  );
}
